<template>
  <span>
    <span
      class="rf-button-input relative"
      :class="{
        'rf-button-input--has-value [&_.rf-input .rf-button-input--search-icon svg]:fill-blue-50 [&_.rf-input.rf-input--base]:outline-1 [&_.rf-input.rf-input--base]:outline-blue-50':
          model,
      }"
      data-cy="search"
    >
      <Transition :duration="200" name="button-input" mode="out-in">
        <span v-if="closed" key="button">
          <button
            class="rf-button-input--button text-body text-grey-1 flex items-center justify-center"
            :aria-expanded="!closed"
            @click="open"
          >
            <component
              :is="props.icon"
              v-if="props.icon"
              class="rf-button-input--button-icon h-6! w-6!"
            />
            {{ text }}
          </button>
        </span>

        <RfInput
          v-else
          key="input"
          ref="inputEl"
          :modelValue="model"
          :size="props.size"
          :placeholder="props.placeholder"
          @update:modelValue="v => (model = v)"
          @blur="close"
        >
          <template #prepend>
            <div class="rf-button-input--search-icon inline-flex pr-2 *:m-auto *:h-6! *:w-6!">
              <component :is="props.icon" v-if="props.icon" />
            </div>
          </template>
          <template #append>
            <button
              class="text-body text-grey-1 inline-flex h-6! w-6!"
              aria-label="Clear"
              @click="clear"
            >
              <RfCloseIcon class="m-auto h-6! w-6!" />
            </button>
          </template>
        </RfInput>
      </Transition>
    </span>
  </span>
</template>

<script setup>
import { nextTick, ref, watchEffect } from "vue";
import RfCloseIcon from "@/components/icons/RfCloseIcon.vue";
import RfInput from "@/components/inputs/RfInput.vue";

const model = defineModel({ type: String, default: "" });

const props = defineProps({
  text: { type: String, default: "Default" },
  icon: { type: undefined, default: null },
  placeholder: { type: String, default: "Input" },
  size: { type: String, default: "base", validator: v => ["base"].includes(v) },
});

const closed = ref(true);
const inputEl = ref();

const open = focus => {
  closed.value = false;
  if (focus) setTimeout(() => inputEl.value?.$el.querySelector("input").focus(), 250);
};

const close = () => {
  if (!model.value) {
    closed.value = true;
  }
};

const clear = () => {
  model.value = null;
  nextTick(close);
};

watchEffect(() => model.value && open(false));

defineExpose({ closed });
</script>

<style lang="scss" scoped>
.button-input-enter-active {
  transition: all 0.2s ease-out;
}

.button-input-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.button-input-enter-from,
.button-input-leave-to {
  opacity: 0;
}

.rf-button-input {
  &--button {
    gap: 9px;
    padding: 8px 12px 8px 17px;
  }
}
</style>
